// extracted by mini-css-extract-plugin
export default {"draggable":"w+oRH","dragging":"_8KC1f","afterFade":"_7Tjnk"};